// @flow

import type { ReferralTrackerState } from "./types";

export const initialState: ReferralTrackerState = {
  error: null,
  requestsInProgress: 0,
  newReferrals: {
    newReferrals: 0,
    employeeLedReferrals: 0,
    managerLedReferrals: 0,
    manualReferrals: 0,
    overdueReferrals: 0,
    supplierReferralTasks: {
      content: [],
      pagination: {
        offset: 0,
        pageNumber: 0,
        pageSize: 0,
        sort: {
          orders: [],
        },
      },
      totalElements: 0,
    },
  },
  activeReferrals: {
    currentActiveReferrals: 0,
    referralsLessThanSevenDaysOld: 0,
    referralsLessThanThirtyDaysOld: 0,
    referralsLessThanNinetyDaysOld: 0,
    referralsOlderThenNinetyDays: 0,
    supplierReferralTasks: {
      content: [],
      pagination: {
        offset: 0,
        pageNumber: 0,
        pageSize: 0,
        sort: {
          orders: [],
        },
      },
      totalElements: 0,
    },
  },
  closedReferrals: {
    supplierReferralTasks: {
      content: [],
      pagination: {
        offset: 0,
        pageNumber: 0,
        pageSize: 0,
        sort: {
          orders: [],
        },
      },
      totalElements: 0,
    },
  },
  closedReferralsStatuses: [],
  referralDetails: {
    employeeDetails: {
      firstName: "",
      lastName: "",
      employeeRef: "",
      jobTitles: "",
      departments: "",
    },
    referralDetails: {
      dateReferred: "",
      referralType: "",
      referredBy: "",
      referralReason: "",
    },
    absenceHistory: [],
    referralQuestions: [],
    lineManagers: [],
    supplierTracking: "",
  },
  referralRTWDetails: {
    rtwDate: "",
    fitDate: "",
  },
  referralLogDetails: [],
  referralStatusDetails: {
    test: "?",
  },
  modals: {
    showReferralDetails: false,
    showRTWReferralDetails: false,
    showLogReferralDetails: false,
    showStatusReferralDetails: false,
  },
  commonData: {
    clientId: 0,
    referralType: "",
    supplierReferralId: 0,
    outcomeOptions: [],
  },
};

export default initialState;
